// The co-pilot's icons, as the screen draws them (CopilotPanel.html's symbols): strokes only, in
// the current colour, so each takes its colour from the text beside it in both palettes.
import type { ReactNode } from 'react';

const PATHS = {
  eyeoff: <><path d="M3 3l18 18" /><path d="M10.6 5.1C11 5 11.5 5 12 5c5 0 9 4.5 10 7-.5 1.2-1.3 2.5-2.5 3.7" /><path d="M6.4 6.4C4.3 7.8 2.8 9.8 2 12c1 2.5 5 7 10 7 1.8 0 3.4-.5 4.8-1.3" /><path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" /></>,
  eye: <><path d="M2 12c1-2.5 5-7 10-7s9 4.5 10 7c-1 2.5-5 7-10 7S3 14.5 2 12z" /><circle cx="12" cy="12" r="3" /></>,
  screen: <><rect x="3" y="4" width="18" height="12" rx="2" /><path d="M8 20h8M12 16v4" /></>,
  share: <><rect x="3" y="4" width="18" height="12" rx="2" /><path d="M12 13V7.5M9.5 10l2.5-2.5 2.5 2.5M8 20h8" /></>,
  ext: <><path d="M14 4h6v6M20 4l-9 9" /><path d="M18 14v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4" /></>,
  check: <path d="M5 12.5l4.5 4.5L19 7.5" />,
  alert: <><path d="M12 4l9 16H3z" /><path d="M12 10v4M12 17.2v.1" /></>,
  send: <path d="M5 12h13M13 6l6 6-6 6" />,
  doc: <><path d="M6 3h9l4 4v14H6z" /><path d="M9 12h6M9 16h6" /></>,
  lock: <><rect x="5" y="11" width="14" height="9" rx="2" /><path d="M8 11V8a4 4 0 0 1 8 0v3" /></>,
  x: <path d="M6 6l12 12M18 6L6 18" />,
  clock: <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>,
  userx: <><circle cx="10" cy="8" r="4" /><path d="M3 21c0-4 3-6 7-6 1.5 0 2.8.3 4 .8" /><path d="M16 15l5 5M21 15l-5 5" /></>,
  book: <><path d="M5 5a2 2 0 0 1 2-2h12v15H7a2 2 0 0 0-2 2z" /><path d="M5 20a2 2 0 0 0 2 2h12v-4" /></>,
  upload: <><path d="M12 16V4M7 9l5-5 5 5" /><path d="M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3" /></>,
} satisfies Record<string, ReactNode>;

export type IconName = keyof typeof PATHS;

export function Icon({ name, className }: { name: IconName; className?: string }) {
  return <svg className={className ? `ico ${className}` : 'ico'} viewBox="0 0 24 24" aria-hidden="true">{PATHS[name]}</svg>;
}
